module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-2-photo-6-103e69b9f749f9ee10077cafc3251edd.webp";